export const VAT_VALIDATION_STATUS = {
  VALID: 'valid',
  NOT_VALID: 'notValid',
  COULD_NOT_VALIDATE: 'couldNotValidate',
};
